import { render, staticRenderFns } from "./trading.vue?vue&type=template&id=ab9b41aa&scoped=true"
import script from "./trading.vue?vue&type=script&lang=js"
export * from "./trading.vue?vue&type=script&lang=js"
import style0 from "./agreement.css?vue&type=style&index=0&id=ab9b41aa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b41aa",
  null
  
)

export default component.exports